import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { postOtaTask, putOtaTask, getDevicesTree, getPackageList, getDeviceType, getOtaDetail } from '@blade-sxp/ota-management/api/index';
import treeSelect from '@blade/common/components/tree-multiple-select/index.vue';
import { isEmpty, map } from 'lodash';
import moment from 'moment';
let default_1 = class extends Vue {
    typesList = [];
    deviceId = '';
    rtspAddress = '';
    treeData = [];
    ruleForm = {
        packageId: '',
        deviceList: [],
        taskType: 'ONCE',
        deviceType: '',
        taskExecuteTime: '',
    };
    loading = false;
    rules = {
        packageId: { required: true, message: this.$t('PleasePackage'), trigger: 'blur' },
        deviceList: { required: true, message: this.$t('pleaseDeviceIdList'), trigger: 'blur' },
        deviceType: { required: true, message: this.$t('PleaseSelectDeviceType'), trigger: 'blur' },
        taskType: { required: true, message: this.$t('PleaseTaskType'), trigger: 'change' },
    };
    selectedPackage = {};
    isEdit = false;
    packageList = [];
    get pickerOptions() {
        const date = this.ruleForm.taskExecuteTime.split(' ')[0];
        const curDate = moment(Date.now()).format('YYYY-MM-DD');
        let start = '';
        if (curDate === date) {
            start = moment(Date.now()).format('HH:mm:ss');
        }
        else {
            start = '00:00:00';
        }
        return {
            disabledDate: (time) => {
                return time.getTime() < Date.now() - 8.64e7;
            },
            selectableRange: `${start} - 23:59:59`,
        };
    }
    onCancel() {
        this.$router.back();
    }
    handelPackageChange(val) {
        for (let i = 0, len = this.packageList.length; i < len; i++) {
            if (this.packageList[i].id === val) {
                this.selectedPackage = {
                    ...this.packageList[i],
                };
                break;
            }
        }
    }
    getDevicesTree() {
        return getDevicesTree().then((res) => {
            this.treeData = this.mapTreeAndSelectAll(res?.data?.data?.tree);
        });
    }
    mapTreeAndSelectAll(originTree) {
        if (isEmpty(originTree)) {
            return [];
        }
        else {
            return map(originTree, (source) => {
                const { treeId, children, name, nodeType, deviceType } = source;
                const key = treeId + name;
                const isGroup = nodeType === 'DEVICE_GROUP';
                const result = {
                    id: treeId,
                    key,
                    label: name,
                    children: this.mapTreeAndSelectAll(children),
                    disabled: (isEmpty(children) && isGroup) || (!isGroup && this.ruleForm.deviceType && deviceType !== this.ruleForm.deviceType),
                };
                result.disabled = result.disabled || this.allChildrenDisabled(result, source);
                return result;
            });
        }
    }
    allChildrenDisabled(node, source) {
        const { children } = node;
        if (source.nodeType !== 'DEVICE_GROUP') {
            return false;
        }
        for (let item of children) {
            if (!item.disabled) {
                return false;
            }
        }
        return true;
    }
    getPackageList() {
        let data = {
            taskId: this.deviceId,
        };
        getPackageList(data).then((resp) => {
            const { packageList } = resp.data.data;
            this.packageList = packageList;
            this.ruleForm.packageId = this.ruleForm?.packageId || packageList[0]?.id;
            this.handelPackageChange(this.ruleForm?.packageId);
        });
    }
    getDeviceType() {
        return getDeviceType().then((resp) => {
            this.typesList = resp.data.data;
            if (!this.ruleForm.deviceType) {
                this.ruleForm.deviceType = this.typesList[0];
            }
        });
    }
    handelTypeChange(val) {
        this.ruleForm.deviceType = val;
        this.getDevicesTree();
    }
    updateOtaTask(data) {
        putOtaTask(data, String(this.deviceId))
            .then((resp) => {
            this.$message({
                message: resp.data.message,
                type: 'success',
            });
            this.$router.back();
        })
            .catch((err) => {
            this.$message.error(String(err));
        });
    }
    newOtaTask(data) {
        postOtaTask(data)
            .then((resp) => {
            this.$message({
                message: resp.data.message,
                type: 'success',
            });
            this.$router.back();
        })
            .catch((err) => {
            this.$message.error(String(err));
        });
    }
    handleSubmit() {
        this.$refs['ruleForm'].validate((valid) => {
            if (valid) {
                let data = {
                    packageId: this.ruleForm.packageId,
                    deviceIdList: this.ruleForm.deviceList.map((item) => item.id),
                    productName: this.ruleForm.deviceType,
                    taskExecuteTime: this.ruleForm.taskType === 'ONCE' ? moment(Date.now()).format('YYYY-MM-DD HH:mm:ss') : this.ruleForm.taskExecuteTime,
                };
                if (this.deviceId) {
                    this.updateOtaTask(data);
                }
                else {
                    this.newOtaTask(data);
                }
            }
            else {
                return false;
            }
        });
    }
    getTaskDetail() {
        return getOtaDetail(String(this.deviceId)).then((resp) => {
            this.ruleForm.taskType = 'CUSTOMED';
            const { packageId, taskExecuteTime, productName, deviceLiteInfoList } = resp.data.data;
            this.ruleForm.packageId = packageId;
            this.ruleForm.taskExecuteTime = taskExecuteTime;
            this.ruleForm.deviceList = this.mapDeviceList(deviceLiteInfoList);
            this.ruleForm.deviceType = productName;
        });
    }
    mapDeviceList(data) {
        if (isEmpty(data)) {
            return [];
        }
        else {
            return map(data, (source) => {
                const { deviceId, deviceName } = source;
                const key = deviceId + deviceName;
                const result = {
                    id: deviceId,
                    key,
                    label: deviceName,
                };
                return result;
            });
        }
    }
    async mounted() {
        this.loading = true;
        const query = this.$route.query;
        const { taskId } = query;
        if (taskId) {
            this.deviceId = taskId;
            this.isEdit = true;
            await this.getTaskDetail();
        }
        Promise.all([this.getPackageList(), this.getDeviceType()])
            .then(() => {
            this.getDevicesTree();
        })
            .catch((err) => {
            this.$message.error(String(err));
        })
            .finally(() => {
            this.loading = false;
        });
    }
};
default_1 = __decorate([
    Component({
        name: 'Form',
        components: {
            treeSelect,
        },
        i18n: {
            messages: {
                'en-us': {
                    editInfo: 'Edit Information',
                    selectDeviceType: 'Select Device Type:',
                    SelectDevice: 'Associated Device Group:',
                    hardware: 'hardware',
                    selectDevice: 'Select the device/device group',
                    numberOfDevices: 'Quantity: ',
                    currentDeviceVersion: 'current Device Version',
                    selectUpdatePackage: 'Select Update Package:',
                    pleaseSelect: 'Please Select',
                    packageType: 'Type',
                    packageVersion: 'Version',
                    updateTime: 'Update Time:',
                    once: 'Immediate',
                    customTime: 'Custom Start',
                    submit: 'submit',
                    pleaseSelectDeviceType: 'Please select the device type',
                    pleasePackage: 'Please select the update package!',
                    pleaseDeviceIdList: 'Please select device/device group',
                    pleaseTaskTime: 'Please Select Date & Time',
                    liveVideo: 'Video Stream',
                    owningGroup: 'Group',
                    equipmentCategory: 'Main Category',
                    owningSubclass: 'Detailed Category',
                    charactersLimit: 'Input content within 50 characters',
                    toAdd: 'No Record, click to add',
                },
                zh: {
                    editInfo: '编辑信息',
                    selectDeviceType: '选择设备类型: ',
                    SelectDevice: '选择设备/设备组: ',
                    hardware: '硬件',
                    selectDevice: '选择设备/设备组 ',
                    numberOfDevices: '设备数量',
                    currentDeviceVersion: '设备当前版本号',
                    selectUpdatePackage: '选择更新包: ',
                    pleaseSelect: '请选择',
                    packageType: '更新包类型',
                    packageVersion: '更新包版本号',
                    updateTime: '更新时间: ',
                    once: '立即',
                    customTime: '自定义时间: ',
                    submit: '确定',
                    pleaseSelectDeviceType: '请选择设备类型',
                    pleasePackage: '请选择更新包!',
                    pleaseDeviceIdList: '请选择设备/设备组',
                    pleaseTaskTime: '请选择日期时间',
                    liveVideo: '实时流视频',
                    owningGroup: '所属设备组',
                    equipmentCategory: '所属设备大类',
                    owningSubclass: '所属设备子类',
                    charactersLimit: '输入内容在50个字符以内',
                    toAdd: '暂无数据点击添加',
                },
            },
        },
    })
], default_1);
export default default_1;
